import apiClient, { extractData } from "./client";

export async function getOvertimes(params = {}) {
  const response = await apiClient.get("/overtime", { params });
  return extractData(response);
}

export async function getMyOvertimes() {
  const response = await apiClient.get("/overtime/mine");
  return extractData(response);
}

export async function getOvertime(id) {
  const response = await apiClient.get(`/overtime/${id}`);
  return extractData(response);
}

export async function getOvertimeHistory(id) {
  const response = await apiClient.get(`/overtime/${id}/history`);
  return extractData(response);
}

export async function createOvertime(data) {
  const response = await apiClient.post("/overtime", data);
  return extractData(response);
}

/** Employee submits OT request for selected pending attendance days */
export async function createEmployeeOvertime(data) {
  const response = await apiClient.post("/overtime/request", data);
  return extractData(response);
}

export async function approveOvertime(id, data = {}) {
  const response = await apiClient.post(`/overtime/${id}/approve`, data);
  return extractData(response);
}

export async function rejectOvertime(id, data = {}) {
  const response = await apiClient.post(`/overtime/${id}/reject`, data);
  return extractData(response);
}

export async function cancelOvertime(id) {
  const response = await apiClient.post(`/overtime/${id}/cancel`);
  return extractData(response);
}
